import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenCheckIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 48,
	viewBox: "0 0 46 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.891,
			cy: 29.9509,
			rx: 3.76599,
			ry: 3.67747,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24,
			cy: 26.4539,
			rx: 17,
			ry: 16.9949,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 42.5318,
			cy: 39.4012,
			rx: 2.53176,
			ry: 2.62677,
			fill: "#2DAB77"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 35.0127,
			cy: 46.2304,
			rx: 1.0127,
			ry: 1.05071,
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 31.0127,
			cy: 1.05071,
			rx: 1.0127,
			ry: 1.05071,
			fill: "#2DAB77"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 26.5,
			cy: 7.88067,
			rx: 2.5,
			ry: 2.62677,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 44.7637C31.9 44.7637 40 36.6661 40 26.769C40 16.872 31.9 8.77441 22 8.77441C12.1 8.77441 4 16.872 4 26.769C4 36.6661 12.1 44.7637 22 44.7637Z",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2031 25.9469L19.3915 31.1478L29.7865 20.7461",
			stroke: "#0DC277",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGreenCheckIcon;
